import React, { useImperativeHandle } from "react";
import { useRequest, useUpdateEffect } from "ahooks";
import { getAlarmedTemplateListApi } from "@/apis/apiCollection";
import SingleSelector from "../SingleSelector";
import { useTranslation } from "@/langs/useTranslation";
import { useGlobalState } from "@/GlobalProvider";

const AlarmTemplateList = React.forwardRef(
  ({ disabled, name, value, onChange }, ref) => {
    const { t } = useTranslation();
    const { currentCompanyId } = useGlobalState();
    const { data = [], run } = useRequest(async () => {
      const res = await getAlarmedTemplateListApi();
      return res.alarmedTemplates.map(item => ({
        id: item.alarmTemplateId,
        name: item.alarmTemplateName
      }));
    });

    useUpdateEffect(run, [currentCompanyId]);

    useImperativeHandle(ref, () => ({
      getOptions: () => data
    }));

    return (
      <SingleSelector
        placeholder={t({ defaultMessage: "报警模板" })}
        disabled={disabled}
        options={data}
        clearable
        style={{ width: 200 }}
        name={name}
        value={value}
        onChange={onChange}
      />
    );
  }
);

export default AlarmTemplateList;
